export const cbtExercises = [
  {
    id: 1,
    title: '💭 Thought Reframing',
    description: 'When you notice negative self-talk or harsh inner criticism',
    instruction: [
      'Step 1: Notice the negative thought without judgment. Write it down.',
      'Step 2: Ask yourself: Is this 100% true? What would I tell a friend?',
      'Step 3: Reframe it with a kinder, more balanced perspective.',
    ],
    icon: '💭',
    type: 'thought_reframing',
  },
  {
    id: 2,
    title: '🧘 Stress Reset Pause',
    description: 'When you feel stress building or your nervous system is activated',
    instruction: [
      'Step 1: Notice where you feel stress in your body. Name it.',
      'Step 2: Take 5 slow breaths. Feel your feet on the ground.',
      'Step 3: Notice 3 things you can see around you. Ground yourself.',
    ],
    icon: '🧘',
    type: 'stress_reset',
  },
  {
    id: 3,
    title: '📋 Overwhelm Breakdown',
    description: 'When you feel overloaded with too many tasks or responsibilities',
    instruction: [
      'Step 1: List everything on your mind. Don\'t organize it yet.',
      'Step 2: Pick ONE thing. Just one. Everything else can wait.',
      'Step 3: Do that one thing for 10 minutes or plan when you\'ll do it.',
    ],
    icon: '📋',
    type: 'overwhelm',
  },
  {
    id: 4,
    title: '🔍 Anxiety Reality Check',
    description: 'When you\'re caught in catastrophic thinking or "what if" spirals',
    instruction: [
      'Step 1: Name the worst-case scenario your mind is predicting.',
      'Step 2: Ask: What\'s the evidence? Has this happened before? What\'s likely?',
      'Step 3: Name one thing you\'ve worried about that didn\'t happen.',
    ],
    icon: '🔍',
    type: 'anxiety',
  },
  {
    id: 5,
    title: '💖 Self-Compassion Reflection',
    description: 'When you\'re being harsh with yourself or feeling shame',
    instruction: [
      'Step 1: What are you criticizing yourself for? Be specific.',
      'Step 2: Would you judge a friend this harshly? You\'re human. Mistakes are learning.',
      'Step 3: Place your hand on your heart. Say: "I deserve kindness."',
    ],
    icon: '💖',
    type: 'compassion',
  },
];
